import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 24,
  medium: 17,
  small: 12,
  xSmall: 9
};
const PinterestFilledIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 15.1C6.5 10.6261 10.127 7 14.601 7C19.074 7 22.7 10.6261 22.7 15.1C22.7 19.5729 19.074 23.2 14.601 23.2C13.803 23.2 13.033 23.0828 12.305 22.8676C12.612 22.3809 12.949 21.757 13.12 21.1331C13.22 20.7721 13.69 18.9062 13.69 18.9062C13.972 19.4434 14.794 19.9158 15.669 19.9158C18.273 19.9158 20.04 17.5422 20.04 14.3647C20.04 11.9625 18.004 9.72413 14.911 9.72413C11.062 9.72413 9.123 12.4835 9.123 14.7847C9.123 16.1773 9.65 17.4165 10.781 17.8794C10.967 17.9546 11.133 17.8813 11.187 17.6765C11.224 17.5346 11.314 17.1745 11.352 17.0269C11.406 16.8231 11.385 16.7516 11.235 16.5745C10.91 16.1896 10.701 15.6915 10.701 14.9857C10.701 12.9398 12.232 11.1072 14.69 11.1072C16.864 11.1072 18.059 12.4359 18.059 14.2104C18.059 16.5468 17.026 18.5166 15.492 18.5166C14.644 18.5166 14.01 17.8165 14.213 16.9574C14.456 15.9315 14.929 14.8238 14.929 14.0827C14.929 13.4198 14.572 12.8664 13.835 12.8664C12.969 12.8664 12.273 13.7627 12.273 14.9638C12.273 15.7277 12.532 16.2449 12.532 16.2449C12.532 16.2449 11.646 20.0015 11.49 20.6587C11.345 21.2741 11.326 21.9532 11.35 22.519C8.495 21.2664 6.5 18.4166 6.5 15.1Z",
        fill: "currentColor"
      }
    )
  );
};
PinterestFilledIcon.iconName = "PinterestFilledIcon";

export { PinterestFilledIcon };
